
























import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Menu from "./Menu.vue";
import ActionsUnauthenticated from "./ActionsUnauthenticated.vue";
import ActionsAuthenticated from "./ActionsAuthenticated.vue";
import {
  changeNavbarTheme,
  NavBarTheme,
  navDarkTheme,
  navDefaultTheme,
  navLightTheme
} from "@/components/NavBar/navbar-theme";
import LocaleSelector from "@/components/Shared/LocaleSelector.vue";
import { authModule } from "@/utils/store-acessor";
import SearchChallenge from "@/components/SearchChallenge.vue";

@Component({
  components: {
    Menu,
    LocaleSelector,
    ActionsUnauthenticated,
    ActionsAuthenticated,
    SearchChallenge
  }
})
export default class NavBar extends Vue {
  @authModule.Getter("isAuthenticated") isAuthenticated!: boolean;

  @Prop({ default: true })
  isScrollAware!: boolean;

  @Prop({ default: "transparent" })
  backgroundColor!: string;

  @Prop({ default: true })
  flatBar!: boolean;

  @Prop({ default: false })
  haveOpacity!: boolean;

  @Prop({ default: "light" })
  theme!: "light" | "dark" | "default";

  @Prop({ required: false, default: false })
  hasExtension!: boolean;

  hasBackground: boolean = false;

  // Snackbar
  snackbarVisibility: boolean = false;
  snackbarColor: string | null = null;
  snackbarText: string = "";

  mounted() {
    // First render navbar theme
    this.setNavBarTheme();

    if (this.isScrollAware) {
      window.addEventListener("scroll", this._onScroll);
    }

    this.$store.subscribe(({ type, payload }, state) => {
      switch (type) {
        case "auth/logoutSuccess":
          return;
        case "auth/authenticationSuccess":
          this.snackbarVisibility = true;
          this.snackbarColor = "green";
          this.snackbarText = "Success! Welcome back.";
          return;
        case "auth/authenticationFailed":
          this.snackbarVisibility = true;
          this.snackbarColor = "red";
          this.snackbarText = payload.message.substring(0, 100) || "Oops! Something went wront, try again.";
          return;
      }
    });
  }

  get formatted(): string {
    return this.haveOpacity ? "background: rgba(229,41,45, 1);" : "";
  }

  _onScroll() {
    this.hasBackground = window.scrollY > 3;
  }

  @Watch("theme")
  setNavBarTheme() {
    changeNavbarTheme(this.getNavBarTheme());
  }

  toHome() {
    this.$router.replace({ path: "/" });
  }

  private getNavBarTheme(): NavBarTheme {
    switch (this.theme) {
      case "light":
        return navLightTheme;
      case "dark":
        return navDarkTheme;
      case "default":
        return navDefaultTheme;
    }
  }
}
